<script setup lang="ts">
/**
 * The template's testimonial cards: hairline border, green star rating, the
 * quote, then name and role. Static grid instead of the template's Swiper so
 * nothing extra loads; three cards per row on desktop.
 */
const { t } = useI18n()

const people = [
  { id: 'martin', rating: 5 },
  { id: 'klara', rating: 5 },
  { id: 'marek', rating: 4 },
  { id: 'anna', rating: 5 },
  { id: 'tomas', rating: 5 },
  { id: 'lucie', rating: 4 },
] as const
</script>

<template>
  <section class="sofax">
    <div class="section-space">
      <div class="shell">
        <SofaxSectionHeading :title="t('homepage.testimonials.title')" width="max-w-2xl" />

        <ul class="grid grid-cols-1 gap-6 md:grid-cols-3">
          <li
            v-for="person in people"
            :key="person.id"
            class="flex h-full flex-col rounded-md border border-[#DBDBDB] bg-white p-9 dark:border-gray-700 dark:bg-gray-800"
          >
            <div class="inline-flex gap-x-1 text-2xl text-accent" role="img" :aria-label="`${person.rating}/5`">
              <i
                v-for="star in 5"
                :key="star"
                class="bi"
                :class="star <= person.rating ? 'bi-star-fill' : 'bi-star'"
                aria-hidden="true"
              />
            </div>

            <blockquote class="my-5 flex-1 text-lg font-medium leading-relaxed text-ink dark:text-white">
              {{ t(`homepage.testimonials.${person.id}.quote`) }}
            </blockquote>

            <div>
              <span class="block font-title font-bold text-ink dark:text-white">
                {{ t(`homepage.testimonials.${person.id}.name`) }}
              </span>
              <span class="text-sm text-muted dark:text-gray-400">{{ t(`homepage.testimonials.${person.id}.role`) }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
